import { ComponentProps, FC, ReactNode } from 'react';

export const Leaf: FC<ComponentProps<'svg'> & { defs?: ReactNode }> = props => {
  const path = props.path ?? {};
  return (
    <svg viewBox="0 0 60 90" {...props}>
      <defs>
        <linearGradient id="gradient" x1="25.59" y1="-11.8536" x2="25.59" y2="107.278" gradientUnits="userSpaceOnUse">
          <stop stop-color="#E6B433" />
          <stop offset="0.32" stop-color="#ECC354" />
          <stop offset="0.405" stop-color="#FFF6C5" />
          <stop offset="0.485" stop-color="#FFEB7E" />
          <stop offset="0.795" stop-color="#E8B83C" />
          <stop offset="1" stop-color="#FFE96D" />
        </linearGradient>
      </defs>
      <path
        fill={props.fill}
        stroke="#6B5C3F"
        strokeWidth={3}
        d="m57.13,84.12c-11.09-1.23-19.67-5.61-25.56-13.03.12.04.24.07.35.09,2.42.39,7.66-2.39,9.25-12.14,1.59-9.75-4.16-18.81-4.2-18.81-.01,0-8.38,6.74-9.96,16.49-.4,2.47-.43,4.59-.2,6.39-3.05-6.88-4.12-14.52-3.94-21.86.2.28.42.49.63.63,1.66,1.09,6.46.73,10.83-5.97,4.37-6.71,3.06-15.3,3.04-15.32,0,0-8.41,2.26-12.78,8.96-.21.33-.4.65-.59.97.67-3.61,1.57-6.98,2.62-9.95,0-.02,0-.03,0-.05,1.85-.3,4.62-2.23,6.18-7.46C34.73,6.63,31.62.01,31.59,0c0,0-6.24,3.84-8.16,10.3-1.45,4.88-.35,7.96.89,9.36-.02.03-.04.05-.05.09-.76,2.13-1.43,4.48-2.01,6.95-.21-1.52-.77-3.3-1.87-5.34-3.44-6.34-10.81-8.99-10.83-8.98,0,0-1.82,7.63,1.62,13.97,3.44,6.34,7.88,6.91,9.29,6.15.27-.14.54-.39.79-.71-.95,5.98-1.23,12.5-.39,18.95-.79-1.02-1.72-2.07-2.88-3.14C10.75,40.88.02,40.66,0,40.7c0,0,.98,10.71,8.22,17.43,7.24,6.72,13.25,5.52,14.75,3.91.16-.18.31-.4.45-.66.99,2.72,2.21,5.37,3.78,7.86,1,1.61,2.11,3.09,3.3,4.48-1.2-.31-2.52-.56-4.01-.71-9.83-.97-18.5,5.34-18.51,5.38,0,.01,7.26,7.93,17.09,8.9,9.83.97,13.9-3.62,14.11-5.81.02-.14.02-.29,0-.45,4.99,2.96,10.88,4.82,17.65,5.58.05,0,.09,0,.14,0,.62,0,1.17-.47,1.24-1.11.07-.69-.42-1.31-1.1-1.38h0Z"
        {...path}
      />
    </svg>
  );
};
